export default {
  dragAndDropYourFilesHereOr: "Drag and drop your files here or",
  uploadFiles: "Upload files",
};
